/**********************************************************************
 *
 * Copyright (C) 2022 Almendo Technologies GmbH
 * Copyright (C) 2022 Marcus Harringer
 *
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of
 * Marcus Harringer. The intellectual and technical concepts contained
 * herein are proprietary to Marcus Harringer and may be covered
 * copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Marcus Harringer.
 *
 ***********************************************************************/
import PropTypes from 'prop-types';
import { experimentalStyled } from '@mui/material/styles';

const LabelRoot = experimentalStyled('span')((({ theme, styleprops }) => {
  const main = theme.palette[styleprops.color].main;
  const outlined = styleprops.variant === 'outlined';

  return {
    alignItems: 'center',
    backgroundColor: outlined ? 'transparent' : main,
    border: outlined ? `1px solid ${main}` : '1px solid transparent',
    borderRadius: theme.shape.borderRadius,
    color: outlined ? main : theme.palette[styleprops.color].contrastText,
    cursor: 'default',
    display: 'inline-flex',
    flexGrow: 0,
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(11),
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'center',
    letterSpacing: 0.5,
    minWidth: 20,
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    //textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  };
}));

/**********************************************************************
 * PAGE
***********************************************************************/
const Label = (props) => {
  const { color = 'primary', variant = 'filled', children, ...other } = props;

  const styleprops = { color, variant };

  return (
    <LabelRoot
      styleprops={styleprops}
      {...other}
    >
      {children}
    </LabelRoot>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['filled', 'outlined']),
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'warning',
    'success',
    'grey',
    'grey_light',
    'green',
    'theme_bg',
    'severity_info',
    'severity_normal',
    'severity_deviation',
    'severity_warning',
    'severity_critical'
  ])
};

export default Label;
